import * as Colours from "../../../globalStyles/administratorColors";

export const body = {
    paddingTop: "30px",
    paddingRight: "20px"
};

export const card = {
    backgroundColor: Colours.primary,
    color: "white",
    cursor: "pointer"
};
